import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Insight, useInsight } from '../office';
import { reportsIntelApi } from '@verlo/shared/services/api';

/**
 * A KPI tile's read — `POST /reports/explain-variance`. A small trigger on the tile opens
 * the `Insight` piece beneath it; when Insight is off for the org, the trigger is not there.
 */
const ExplainVarianceBubble = ({ kpi, range, siteLabel, context }) => {
  const { enabled } = useInsight();
  const [open, setOpen] = useState(false);
  if (!enabled) return null;
  const read = () => reportsIntelApi.explainVariance({
    kpi_key: kpi.key,
    label: kpi.label,
    value: kpi.value,
    previous: kpi.previous ?? null,
    target: kpi.target ?? null,
    format: kpi.format,
    range,
    site_label: siteLabel,
    context: context || null,
  });
  return (
    <div className="w-full" data-testid={`explain-variance-${kpi.key}`}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-1 font-heading text-[11px] font-bold uppercase tracking-[0.06em] text-verlo hover:underline"
        data-testid={`explain-variance-btn-${kpi.key}`}
        aria-expanded={open}
      >
        Verlo Insight {open ? <ChevronUp size={11} /> : <ChevronDown size={11} />}
      </button>
      {open && (
        <Insight
          key={`${kpi.key}:${range}:${kpi.value}`}
          read={read}
          purpose={`Why ${kpi.label.toLowerCase()} moved, and one thing to do about it.`}
          compact
          className="mt-2"
          testId={`explain-variance-body-${kpi.key}`}
        />
      )}
    </div>
  );
};

export default ExplainVarianceBubble;
